import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogVariantOptions } from 'shared/assets/styles';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { useDeleteTasksMutation } from 'shared/hooks/queries/use-delete-tasks-mutation';
import { Task } from 'shared/types/task';

import * as Styled from './empty-trash-dialog.style';

export type EmptyTrashDialogProps = {
  tasks: Task[];
  onClose: () => void;
};

export const EmptyTrashDialog: React.FC<EmptyTrashDialogProps> = ({
  tasks,
  onClose,
}) => {
  const { t } = useTranslation();
  const { mutate: deleteTasks } = useDeleteTasksMutation();

  const onEmpty = () => {
    deleteTasks(tasks.map((task) => task.id));
    onClose();
  };

  return (
    <Dialog open onClose={onClose} variant={DialogVariantOptions.ExtraSmall}>
      <Styled.DialogHeader>
        <Typography variant="h5" component="h1">
          {t('trash.empty-confirm-title')}
        </Typography>
      </Styled.DialogHeader>

      <Styled.DialogBody>
        <Typography variant="body2">
          {t('trash.empty-confirm-message')}
        </Typography>
      </Styled.DialogBody>

      <Styled.DialogFooter>
        <Button
          variant={Variants.Contained}
          size={Sizes.Medium}
          color={Colors.TextPrimary}
          onClick={onClose}
        >
          {t('general.cancel')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onEmpty}>
          {t('trash.empty-confirm-submit')}
        </Button>
      </Styled.DialogFooter>
    </Dialog>
  );
};
